import "./MetaDocPageDeletionScreen.scss";
import "./MetaDocPageMovementScreen.scss";

import LoadingIcon from "components/Loading/LoadingIcon";

type MetaDocOperationOverlayScreenProps = {
  classNameBase: "metadoc-page-movement" | "metadoc-page-deletion";
  title: string;
  mainIcon: string;
  statusText: string;
  statusIcon?: string;
  subtitle?: string;
  showSpinner?: boolean;
};

/**
 * shared overlay presenter for metadoc operation states.
 * renders consistent lock-screen content for long-running operations.
 */
const MetaDocOperationOverlayScreen = ({
  classNameBase,
  title,
  mainIcon,
  statusText,
  statusIcon = "hourglass_empty",
  subtitle = "Processing time varies based on document size...",
  showSpinner = true,
}: MetaDocOperationOverlayScreenProps) => {
  return (
    <div className={classNameBase}>
      <div className={`${classNameBase}__content`}>
        <div className={`${classNameBase}__icon-container`}>
          <span className={`material-icons ${classNameBase}__main-icon`}>
            {mainIcon}
          </span>
        </div>

        <h2 className={`${classNameBase}__title`}>{title}</h2>

        <div className={`${classNameBase}__message`}>
          <span className={`material-icons ${classNameBase}__message-icon`}>
            {statusIcon}
          </span>
          <span className={`${classNameBase}__message-text`}>{statusText}</span>
        </div>

        {showSpinner && <LoadingIcon size="large" showText={false} />}

        <p className={`${classNameBase}__subtitle`}>{subtitle}</p>
      </div>
    </div>
  );
};

export default MetaDocOperationOverlayScreen;
